import { render, staticRenderFns } from "./ExamRecord.vue?vue&type=template&id=075b8206"
import script from "./ExamRecord.vue?vue&type=script&lang=js"
export * from "./ExamRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports